<template>
  <vue-tel-input
    v-model="phoneNumber"
    @keypress.native="filterPhoneNumber($event)"
    :placeholder="_T('Phone number')"
    v-bind="vueTelBindings"
    aria-readonly="true"
  />
</template>
<script>
import { VueTelInput } from 'vue-tel-input'
import ValidationMixin from '@/mixins/ValidationMixin'
import { mapGetters } from 'vuex'
export default {
  name: 'PhoneNumberInput',
  data: () => ({
    phoneNumber: '',
    vueTelBindings: {
      mode: 'international',
      disabledFormatting: true,
      enabledCountryCode: true,
      dropdownOptions: {
        disabledDialCode: false,
        // showDialCodeInList: true,
        showDialCodeInSelection: true,
      },
      inputOptions: {
        // autofocus: true,
        showDialCode: false,
      },
    },
  }),
  mixins: [ValidationMixin],
  computed: {
    ...mapGetters(['_T']),
  },
  watch: {
    phoneNumber: {
      immediate: true,
      handler(val) {
        this.$emit('custom-input', val)
      },
    },
  },
  components: {
    VueTelInput,
  },
}
</script>

<style lang="scss">
.body-rtl {
  .vue-tel-input {
    direction: ltr;
    input {
      // direction: ltr;
      // text-align: left;
    }
  }
}
</style>
